module.exports = __webpack_public_path__ + "static/media/quienessomos.7c534b6f.png";